import USMap from "./us-map";
export default USMap;
